import { ColorSystemDefinition } from "@ancon/wildcat-ui/shared";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormContext } from "react-hook-form";
import { Button } from "reactstrap";
import { styled } from "styled-components";
import { FontVariant } from "../../../constants/fonts";

const Modal = styled.div`
  padding: 30px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  border-radius: 40px;
  width: 390px;
`;

const CloseButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const CircleButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
`;

const ModalTitle = styled.h4`
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
`;

const ModalDesc = styled.p`
  margin-top: 5px;
  margin-bottom: 50px;
`;

const ModalBody = styled.div``;

const ActionButton = styled(Button)`
  border-radius: 30px;
  height: 48px;
  margin-bottom: 5px;
`;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default function CustomModal() {
  const { watch } = useFormContext<ColorSystemDefinition>();
  const values = watch();
  const { primary } = values;
  const { color, content, buttons } = primary;
  const {
    default: defaultContentColor,
    danger,
    alt_1: alt1ContentColor,
  } = content;
  const { default: defaultButton } = buttons;

  return (
    <Modal
      style={{
        backgroundColor: color,
      }}
    >
      <CloseButtonContainer>
        <CircleButton
          style={{
            backgroundColor: defaultButton.color,
          }}
        >
          <FontAwesomeIcon icon={faClose} color={color} />
        </CircleButton>
      </CloseButtonContainer>

      <ModalTitle
        style={{
          color: defaultContentColor,
          fontFamily: FontVariant.PrimaryBold,
        }}
      >
        Delete Account
      </ModalTitle>
      <ModalBody>
        <ModalDesc
          style={{
            color: alt1ContentColor,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          Du kan inte ångra dig om du tar bort din order. Du måste då börja om
          från början.
        </ModalDesc>

        <ActionsContainer>
          <ActionButton
            style={{
              backgroundColor: "transparent",
              color: defaultContentColor,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            Keep Account
          </ActionButton>
          <ActionButton
            style={{
              border: "none",
              backgroundColor: danger,
              color,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            Close Account
          </ActionButton>
        </ActionsContainer>
      </ModalBody>
    </Modal>
  );
}
